import type { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import { WorkspaceIcon } from '@/components/workspace/WorkspaceIcon';

/** Общая карточка аварии; маршрут и корневая граница задают свои действия восстановления */
export function ErrorCard({ description, children }: { description: string; children: ReactNode }) {
	const { t } = useTranslation('common');
	return (
		<div className="ws-empty-state">
			<WorkspaceIcon name="alert" size={32} />
			<h1>{t('errors.somethingWrong')}</h1>
			<p>{t(description)}</p>
			{children}
		</div>
	);
}
